const messagesHandler = (url) => {
  if (/^\/chats\/\d+(\.[a-zA-Z0-9]+)?(\/)?(\?.*)?$/.test(url)) {
    const newUrl = url.split(".")[0];
    return newUrl.replace(/^\/chats/, "/messenger/chats");
  } else if (/^\/chats(\/)?(\?.*)?$/i.test(url)) {
    return url.replace(/^\/chats/, "/messenger");
  } else if (/\/chats\/new(\/.*|\?.*)?$/i.test(url)) {
    return url.replace(/^\/chats\/new/, "/^/messenger/chats/new/");
  }
  return null;
};
export {
  messagesHandler
};
